/**
 * Google Tag Manager tracking utilities
 */

/**
 * Push an event to the dataLayer for GTM tracking
 * @param {Object} eventData - The event data to push
 */
export const pushToDataLayer = (eventData) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push(eventData);
    }
};

/**
 * Push an event to the parent window (for iframe embedding)
 * @param {Object} eventData - The event data to push to parent
 */
export const pushToParent = (eventData) => {
    if (window.parent && window.parent !== window) {
        window.parent.postMessage(eventData, '*');
    }
};

/**
 * Track a button click event
 * @param {string} buttonText - The text of the button clicked
 * @param {string} workbookTitle - The title of the current workbook
 * @param {Object} additionalData - Any additional data to include
 */
export const trackButtonClick = (buttonText, workbookTitle = '', additionalData = {}) => {
    const clickData = {
        event: 'iframe_button_click',
        button_text: buttonText,
        workbook_title: workbookTitle,
        timestamp: Date.now(),
        ...additionalData
    };
    // console.log("Tracking button click: ", clickData)
    
    // Push to GTM dataLayer
    pushToDataLayer(clickData);
    
    // Also push to parent window if in iframe
    pushToParent(clickData);
};

